import { pluginKey } from '../plugin-key';
export var getPluginState = function getPluginState(state) {
  return pluginKey.getState(state);
};